import React from 'react';
import {
  dragToExploreVisibilitySet,
  getCar360Loaded,
  getdragToExploreVisibility,
} from '../../store/car-slice';
import {
  Box,
  Fade,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import theme from '../../config/theme';

export default function DragToExplore() {
  const dispatch = useDispatch();
  const dragToExploreVisibility = useSelector(getdragToExploreVisibility);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  const car360Loaded = useSelector(getCar360Loaded);

  const handleDisableDragToExplore = () => {
    if (!car360Loaded) return;
    dispatch(dragToExploreVisibilitySet(false));
  };

  return (
    <Box
      margin={'auto'}
      sx={{
        left: '50%',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
      }}
      textAlign={'center'}
    >
      <Fade in={dragToExploreVisibility && car360Loaded}>
        <IconButton
          draggable={false}
          onMouseDown={handleDisableDragToExplore}
          onMouseMove={handleDisableDragToExplore}
          onTouchStart={handleDisableDragToExplore}
          sx={{
            padding: 0,
            pointerEvents: 'none',
          }}
        >
          <Box
            onMouseDown={handleDisableDragToExplore}
            sx={{
              background: 'rgba( 0, 0, 0, 0.25 )',
              backdropFilter: 'blur(10px)',
              borderRadius: '10px',
              position: 'absolute',
              paddingBottom: '10px',
              [theme.breakpoints.down('lg')]: {
                paddingBottom: '5px',
              },
            }}
          >
            <Typography
              sx={{
                color: 'white',
                padding: '15px 0',
                fontSize: '1.3rem',
                [theme.breakpoints.down('lg')]: {
                  fontSize: '0.5rem',
                  padding: '10px 0 2px 0',
                },
              }}
            >
              Drag To Explore
            </Typography>
            <Box sx={{ position: 'relative' }}>
              <img
                alt="drag to explore"
                className={
                  isMobile
                    ? 'animate-drag-to-explore-mobile'
                    : 'animate-drag-to-explore-desktop'
                }
                src="/hand-icon.svg"
                style={{
                  width: isMobile ? 25 : 50,
                  height: isMobile ? 25 : 50,
                  position: 'absolute',
                }}
              />

              <img
                alt="drag to explore"
                src="/arrow-icon.svg"
                style={{
                  width: isMobile ? 110 : 280,
                  height: isMobile ? 15 : 45,
                  marginBottom: isMobile ? 3.5 : 0,
                }}
              />
            </Box>
          </Box>
        </IconButton>
      </Fade>
    </Box>
  );
}
